import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  readonly baseURL = DDP_ENV.campaignUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getAllCampaigns(mrn, status, clientId, page, size, regex) {

    if(mrn !== undefined){
          if(status=== undefined||status===''){
               return this._http.get(this.baseURL + '/campaign/' + clientId + '/' + mrn + '?page=' + page + '&size=' + size+'&&regexPattern=' + regex, this.buildHeaders());
          }else{
            return this._http.get(this.baseURL + '/campaign/' + clientId + '/' + mrn + '?page=' + page + '&size=' + size+'&&status='+status+ '&&regexPattern=' + regex, this.buildHeaders());
          }
    }else if(clientId!== undefined){
          if(status=== undefined||status===''){
               return this._http.get(this.baseURL + '/campaign/' + clientId+'?page=' + page + '&size=' + size+'&&regexPattern=' + regex, this.buildHeaders());
          }else{
            return this._http.get(this.baseURL + '/campaign/' + clientId +'?page=' + page + '&size=' + size+'&&status='+status+ '&&regexPattern=' + regex, this.buildHeaders());
          }
    }else{
          if(status=== undefined||status===''){
              return this._http.get(this.baseURL + '/campaign?page=' + page + '&&size=' + size +'&&regexPattern=' + regex, this.buildHeaders());
          }else{
              return this._http.get(this.baseURL + '/campaign?page=' + page + '&&size=' + size +'&&status='+status+ '&&regexPattern=' + regex, this.buildHeaders());
          }
    }

  }

  getAllCampaignByClientId(mrn, clientId, page, size, regex) {
    if (mrn === undefined) {
      // tslint:disable-next-line:max-line-length
      return this._http.get(this.baseURL + '/campaign/' + clientId + '?page=' + page + '&size=' + size + '&regexPattern=' + regex, this.buildHeaders());
    } else {
      return this._http.get(this.baseURL + '/campaign/' + clientId + '/' + mrn + '?page=' + page + '&size=' + size, this.buildHeaders());
    }
  }

  search(regex, page, size) {
    return this._http.get(this.baseURL + '/campaign/?page=' + page + '&size=' + size + '&regexPattern=' + regex, this.buildHeaders());
  }

  getCampaignsDetails(campaignId) {
      return this._http.get(this.baseURL + '/campaign/id/' + campaignId);
  }

  getPatientDetails(patientId) {
      return this._http.get(this.baseURL + '/patients/' + patientId, this.buildHeaders());
  }

  addUpdateCampaign(campaignData) {
    if (campaignData.id === '') {
      return this._http.post(this.baseURL + '/campaign/client/' + campaignData.clientId , campaignData, this.buildHeaders());
    } else {
      return this._http.put(this.baseURL + '/campaign/' + campaignData.id, campaignData, this.buildHeaders());
    }
  }

  downloadQR(campaignId) {
    return this._http.get(this.baseURL + '/qrcode/campaign/' + campaignId + '/download', this.buildHeaders() );
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

  suspendCampaign(updateCampaignRequest){
      return this._http.put(this.baseURL + '/campaign/suspend/' + updateCampaignRequest.campaignId, updateCampaignRequest, this.buildHeaders());
  }
}
